/**
 * Bouwmeester Watersport — GA4 conversie-events (2026-07-20)
 * ==========================================================
 * Vult de bestaande gtag-installatie (G-B8G866B44W) aan met de events uit het
 * conversieplan. Plaatsen vlak voor </body> in theme.liquid, of als snippet
 * {% render %} onderaan de layout. Geen afhankelijkheden; respecteert de
 * bestaande consent-state omdat alles via dezelfde gtag loopt.
 *
 * Events:
 *  - whatsapp_click        klik op wa.me / api.whatsapp.com-link
 *  - tel_click             klik op tel:-link
 *  - mailto_click          klik op mailto:-link (micro, geen key event)
 *  - generate_lead         Shopify contact-form verstuurd; lead_type uit pagina
 *  - part_finder_opened    bezoek aan /pages/part-finder (1x per pagina)
 *  - part_finder_cart_add  cart-add vanuit de PartStream-widget (shapp.php)
 */
(function () {
  "use strict";
  if (typeof window === "undefined") return;

  // Zelfvoorzienend: als er geen gtag (meer) op de pagina staat — bijv. nadat
  // de oude theme-tag is opgeruimd na de Google & YouTube-app-migratie —
  // bootstrappen we hem zelf, zonder extra page_view (de app meet die al).
  var MEASUREMENT_ID = "G-B8G866B44W";
  if (typeof window.gtag !== "function") {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", MEASUREMENT_ID, { send_page_view: false });
    var s = document.createElement("script");
    s.async = true;
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + MEASUREMENT_ID;
    document.head.appendChild(s);
  }

  var track = function (name, params) {
    try {
      window.gtag("event", name, params || {});
    } catch (e) { /* nooit de site breken voor meting */ }
  };

  // ── 1. Klik-events: WhatsApp / telefoon / e-mail ──────────────────────────
  document.addEventListener("click", function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest("a[href]") : null;
    if (!a) return;
    var href = a.getAttribute("href") || "";
    if (/wa\.me|api\.whatsapp\.com/i.test(href)) {
      track("whatsapp_click", { link_url: href, page_path: location.pathname });
    } else if (href.indexOf("tel:") === 0) {
      track("tel_click", { link_url: href, page_path: location.pathname });
    } else if (href.indexOf("mailto:") === 0) {
      track("mailto_click", { link_url: href, page_path: location.pathname });
    }
  }, true);

  // ── 2. Leads: Shopify contact-formulieren ─────────────────────────────────
  // lead_type op basis van de pagina waar het formulier staat.
  var leadTypeForPath = function (path) {
    if (/onderhoud|reparatie|diensten|diagnostische|stalling/i.test(path)) return "afspraak_werkplaats";
    if (/boten|buitenboordmotor|quicksilver|highfield|linder|cremo|hibo|financiering|prijslijst/i.test(path)) return "offerte";
    return "contact";
  };
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (!form || !form.action) return;
    // Shopify contact-forms posten naar /contact met form_type=contact
    var isContact = /\/contact(#|\?|$)/.test(form.action) ||
      (form.querySelector && form.querySelector('input[name="form_type"][value="contact"]'));
    if (!isContact) return;
    track("generate_lead", {
      lead_type: leadTypeForPath(location.pathname),
      page_path: location.pathname,
    });
  }, true);

  // ── 3. Part Finder (PartStream-widget) ────────────────────────────────────
  if (/\/pages\/part-finder/i.test(location.pathname)) {
    track("part_finder_opened", { page_path: location.pathname });

    // Cart-adds lopen via de PHP-middleware (shapp.php). De widget doet dat
    // met fetch/XHR of een navigatie — we vangen alle drie de routes.
    var cartAddSeen = false;
    var markCartAdd = function (source) {
      if (cartAddSeen) return; // 1x per pageview is genoeg voor de conversie
      cartAddSeen = true;
      track("part_finder_cart_add", { source: source, page_path: location.pathname });
    };

    // fetch
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (/shapp\.php|\/cart\/add/i.test(url)) markCartAdd("fetch");
        return origFetch.apply(this, arguments);
      };
    }
    // XHR
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === "string" && /shapp\.php|\/cart\/add/i.test(url)) markCartAdd("xhr");
      return origOpen.apply(this, arguments);
    };
    // Navigatie/klik binnen de widget op een add-to-cart-achtige knop
    document.addEventListener("click", function (ev) {
      var el = ev.target && ev.target.closest
        ? ev.target.closest('a[href*="shapp.php"], a[href*="/cart/add"], button[class*="cart" i], a[class*="cart" i]')
        : null;
      if (el) markCartAdd("click");
    }, true);
  }
})();
